import { Injectable } from '@angular/core';
import { AbstractSandbox } from 'app/core/sandboxes/abstract.sandbox';
import { CustomerInfoService } from 'app/core/services/customer-info.service';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CustomerInfoSandbox extends AbstractSandbox {
  constructor(private customerInfoService: CustomerInfoService) {
    super();
  }

  resetCustomerInfo(): void {
    this.customerInfoService.resetCustomerInfo();
  }

  loadCustomerInfo(customer: Customer): Observable<void> {
    return this.customerInfoService.loadCustomerInfo(customer);
  }
}
